export const BD_PERMISSION_FORBIDDEN_PATH = 'https://www.bindoc.de/details';

export enum BdPermissionFailStrategy {
  REDIRECT = 'REDIRECT',
  DIALOG = 'DIALOG',
}
